export const emailValidator = (value: string) => {
  if (!value) {
    return '';
  }

  const emailRegex = new RegExp(/\S+@\S+\.\S+/);
  return emailRegex.test(value) ? '' : 'Please enter a valid email.';
};

const urlRegex = new RegExp(
  /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i,
);
export const urlValidator = (value: string) => {
  if (value === null) {
    return '';
  }
  return (urlRegex.test(value.trim()) ? '' : 'Please enter a valid url.');
}

export const optionalUrlValidator = (value: string) => (!value || urlRegex.test(value) ? '' : 'Please enter a valid url.');

export const requiredValidator = (value: any) => {
  if (value === null) {
    return '';
  }
  return value ? '' : 'This field is required.';
};

export const regexpValidator = (value: string, regexpValue: string) => {
  if (!regexpValue || regexpValue === '') {
    return;
  }

  const validationRegex = new RegExp(regexpValue, 'i');
  return validationRegex.test(value) ? '' : `Not a valid parameter value. Format should match to pattern '${regexpValue}'`;
};

export const conditionalRequiredValidator = (value: any, isRequired: boolean): string | undefined => {
  if (!isRequired) {
    return undefined;
  }

  if (value === null || value === undefined || String(value).trim() === '') {
    return 'This field is required.';
  }

  return undefined;
};

const phoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/;

export const usPhoneMaskValidator = (value: string) => {
  if (!value) {
    return '';
  }

  if (!phoneRegex.test(value)) {
    return 'Invalid phone format';
  }

  return '';
};

export const requiredArrayValidator = (value: any[]) =>
    (value && value.length > 0) ? "" : "This field is required.";
